<template>
  <div class="problems-widget">
    <Problems
      ref="problems"
      as-widget
      hide-header
      :widget-type-filters="typesFilterParam"
      :widget-zone-filter="zoneFilterParam"
      :widget-impact-filter="impactFilter"
      :widget-sort-by="pbOptSortBy"
      :widget-leaders="pbOptSelectedLeaders"
      :no-delete-btn="!problemWidgetDisplayDeleteButton"
    />
  </div>
</template>

<script>
/**
 * Text widget. Allows the user to type in whatever he wants during configuration
 *
 * @vue-prop {Object} selectedTypes - {type_id: is_selected, ...}
 */

// Components
import Problems from '@/views/dmp/problems.vue';
// Mixins
import mixinWidgets from '@/mixins/widgets.vue';
import mixinPbOptions from '@/mixins/page-options/problems.vue';
import mixinWidgetsBgColor from '@/mixins/widgets-bgcolor-config.vue';
// Utils
import { convertImpactFilterToArray } from '@/utils/problem-utils';

export default {

  name: 'ProblemsWidget',

  components: {
    Problems,
  },

  mixins: [mixinWidgets, mixinWidgetsBgColor, mixinPbOptions],

  props: {
    sortBy: {
      type: Object,
      default: () => ({ value: 3, desc: true }),
    },
    selectedTypes: {
      type: Array,
      default: () => [],
    },
    typesInclusive: {
      type: Number,
      default: 0,
    },
    zoneFilter: {
      type: Array,
      default: () => [],
    },
    zoneInclusive: {
      type: Number,
      default: 0,
    },
    impactFilter: {
      type: [Object, Array],
      default: () => ({ min: 0, max: 3 }),
    },
    problemsLeaders: {
      type: Array,
      default: () => undefined,
    },
    problemWidgetDisplayDeleteButton: Boolean,
  },

  data() {
    return {
      zoneSelected: null,
    };
  },

  computed: {
    config() {
      const specOptions = this.cfgTemplateEdition
        ? this.pbOptions.filter(opt => !['problemsLeadersLegend', 'problemsLeaders'].includes(opt.key))
        : this.pbOptions;
      return [
        {
          key: 'problemWidgetDisplayDeleteButton',
          value: this.problemWidgetDisplayDeleteButton,
          component: 'Checkbox',
          options: { title: this.$t('message.WIDGET_PROBLEMS_SHOW_DELETE_BTN') },
        },
        ...specOptions,
        this.defaultBgColorConfig,
      ];
    },
    /** Zone filter to send through XHR */
    zoneFilterParam() {
      return { zones: this.pbOptZoneSelected, inclusive: this.zoneInclusive };
    },
    typesFilterParam() {
      return { types: this.pbOptSelectedTypes, inclusive: this.typesInclusive };
    },
    // ========= Config options =========
    pbOptSortBy() {
      return this.sortBy;
    },
    /** Return the ids of types that should be selected */
    pbOptSelectedTypes() {
      return this.selectedTypes;
    },
    pbOptTypesInclusive() {
      return this.typesInclusive;
    },
    pbOptZoneInclusive() {
      return this.zoneInclusive;
    },
    pbOptZoneSelected() {
      return this.zoneFilter;
    },
    pbOptImpactFilter() {
      return convertImpactFilterToArray(this.impactFilter);
    },
    pbOptSelectedLeaders() {
      return this.problemsLeaders === undefined ? [] : this.problemsLeaders.map(e => Number(e));
    },
  },

  mounted() {
    this.refresh(true);
  },

  methods: {
    refresh(firstLoad) {
      if (!this.$refs.problems || this.cfgTemplateEdition) {
        return;
      }
      this.$refs.problems.refresh(firstLoad, false);
    },
    sizeChanged() {
      if (this.$refs.problems) {
        this.$refs.problems.onSizeChanged(true);
      }
    },
  },
};

</script>
